import { Cookies } from 'react-cookie';
import uuid from 'uuid';
import { stringify } from 'qs';

import api from './api';

const GA_COOKIE_NAME = '_ga';
const cookieDomain = `.${process.env.SITE_DOMAIN}`;

class Analytics {
  constructor() {
    this.userId = null;
    this.activePage = null;
    this.cookies = new Cookies();
  }

  get uuid() {
    let userId = this.cookies.get(GA_COOKIE_NAME);

    if (!userId) {
      userId = uuid.v4();
      this.cookies.set(GA_COOKIE_NAME, userId, {
        path: '/',
        domain: cookieDomain,
        maxAge: 315360000, // 10 years
      });
    }

    return userId;
  }

  get PID() {
    return this.cookies.get('pid');
  }

  get subID() {
    return this.cookies.get('subid');
  }

  trackEvent() {
    // TODO: remove these calls, GA is not in use anymore
    return this;
  }

  setUserId(id) {
    this.userId = id;
    return this;
  }

  clearUserId() {
    this.userId = null;
    return this;
  }

  setActivePage(page) {
    this.activePage = page;
    return this;
  }

  pageview(page, { title = document.title } = { title: document.title }) {
    setTimeout(() => {
      const payload = {
        dp: page,
        dt: title,
        dh: window.location.origin,
        dr: document.referrer,
        uid: this.userId,
        cid: this.uuid,
        cd3: this.PID, // custom dimension 3
        cd4: this.subID, // custom dimension 4
        sr: `${window.screen.width}x${window.screen.height}`,
        vp: `${window.screen.availWidth}x${window.screen.availHeight}`,
        sd: `${window.screen.colorDepth}-bits`,
        ul: (navigator.language || navigator.userLanguage).toLowerCase(),
        ua: navigator.userAgent,
        vtz: new Date().toString().match(/([A-Z]+[+-][0-9]+)/)[1],
      };

      api
        .get(`/collect?${stringify(payload)}`)
        .catch(() => {
          // that's okay
        });
    }, 0);

    return this;
  }
}

export default new Analytics();
